import React, { useEffect } from 'react';

const TurnstileWidget = () => {
  useEffect(() => {
    const loadTurnstile = async () => {
      console.log({ title: 'Turnstile', message: 'SDK loaded' });
    };

    const turnstileScript = document.getElementById('turnstile-sdk-script');
    if (!window.turnstile && !turnstileScript) {
      // eslint-disable-next-line no-console
      console.log('Turnstile: SDK not loaded yet');
      const s = document.createElement('script');
      s.id = 'turnstile-sdk-script';
      s.type = 'text/javascript';
      s.async = true;
      s.src = `${process.env.TURNSTILE_URL}`;
      s.onload = loadTurnstile;

      document.getElementsByTagName('body')[0].appendChild(s);
    }
  }, []);

  return <div id={process.env.TURNSTILE_DOM_ELEMENT_ID} />;
};

export default TurnstileWidget;
